import React, { createContext, useContext, useEffect, useState } from 'react';
import { normalizeGameType } from '../config/gameTypes';

const GameTypeContext = createContext(undefined);

export const gameTypes = {
  classic5050: {
    id: 'classic5050',
    name: 'Classic 50/50',
    description: 'Traditional 50/50 raffle draw',
    icon: '🎲'
  },
  progressive5050: {
    id: 'progressive5050',
    name: 'Progressive 50/50',
    description: 'Jackpot rolls over until won',
    icon: '🎰'
  },
  prizeDraw: {
    id: 'prizeDraw',
    name: 'Prize Draw',
    description: 'Win amazing prizes',
    icon: '🎁'
  },
  chaseTheAce: {
    id: 'chaseTheAce',
    name: 'Chase the Ace',
    description: 'Progressive jackpot card game',
    icon: '🃏'
  },
  eliminationDraw: {
    id: 'eliminationDraw',
    name: 'Elimination Draw',
    description: 'Last ticket standing wins big',
    icon: '🎯'
  },
  squareGame: {
    id: 'squareGame',
    name: '100/1000 Square',
    description: 'Grid-based number game',
    icon: '⬛'
  },
  modified5050: {
    id: 'modified5050',
    name: 'Modified 50/50',
    description: 'Progressive jackpot charity lottery',
    icon: '💰'
  },
  superballBingo: {
    id: 'superballBingo',
    name: 'Superball Bingo',
    description: 'Draw the golden Superball to win!',
    icon: '🎱'
  }
};

export function GameTypeProvider({ children }) {
  const [gameType, setGameType] = useState(() => {
    const siteConfigGameType = window?.SITE_CONFIG?.defaults?.game_type || window?.SITE_CONFIG?.game_type?.id;
    const normalizedSiteType = normalizeGameType(siteConfigGameType);
    if (normalizedSiteType && gameTypes[normalizedSiteType]) {
      return normalizedSiteType;
    }

    const stored = localStorage.getItem('gameType');
    const normalizedStoredType = normalizeGameType(stored);
    if (normalizedStoredType && gameTypes[normalizedStoredType]) {
      return normalizedStoredType;
    }

    return 'classic5050';
  });

  useEffect(() => {
    localStorage.setItem('gameType', gameType);
  }, [gameType]);

  const changeGameType = (newType) => {
    const normalizedType = normalizeGameType(newType) || newType;
    if (gameTypes[normalizedType]) {
      setGameType(normalizedType);
    }
  };

  return (
    <GameTypeContext.Provider value={{
      gameType,
      currentGame: gameTypes[gameType],
      changeGameType,
      gameTypes
    }}>
      {children}
    </GameTypeContext.Provider>
  );
}

export function useGameType() {
  const context = useContext(GameTypeContext);
  if (context === undefined) {
    throw new Error('useGameType must be used within a GameTypeProvider');
  }
  return context;
}
